import {Component} from "@angular/core";
import {DefaultFormApiAdapter, IForm} from "frontier";
import AppControlGuids from "../../../../../api/ControlGuids";
import {
  CustomDynamicFormComponent
} from 'frontier/browserkit/src/lib/components/control/form-control/dynamic-form/custom-dynamic-form/custom-dynamic-form.component';
import {MatList, MatListItem} from '@angular/material/list';
import {MatCheckbox} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';


class ApiAdapter extends DefaultFormApiAdapter {
  override from(apiData: IForm): IForm {
    if (apiData.formGroups?.[0]) apiData.formGroups[0].header = 'Trapo zuordnen'
    if (apiData.formGroups?.[1]) apiData.formGroups[1].header = 'Revisor'
    return super.from(apiData);
  }
}

@Component({
  selector: 'app-test-rule-settings-config-form',
  templateUrl: 'test-rule-settings-config-form.html',
  styleUrl: 'test-rule-settings-config-form.scss',
  standalone: true,
  imports: [MatList, MatListItem, MatCheckbox, FormsModule],
})
export class TestRuleSettingsConfigForm extends CustomDynamicFormComponent {
  override GUID: string = AppControlGuids.TTestRuleSettingsConfig;

  override apiAdapter = new ApiAdapter();

  assignTrapoChanged(key: string) {
    this.onFormChange({
      elements: this.apiData()?.formGroups[0].elements,
      formGroup: this.apiData()?.formGroups[0],
      changedElement: key
    })
  }

  assignRevisorChanged(key: string) {
    this.onFormChange({
      elements: this.apiData()?.formGroups[1].elements,
      formGroup: this.apiData()?.formGroups[1],
      changedElement: key
    })
  }
}
